import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronUpSquare: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
    ['path', { d: 'm8 14 4-4 4 4' }],
  ],
];

export default ChevronUpSquare;
